import React, {useState} from 'react'
import {createAddress} from "../../services/serviceAddress";
import {Button, Form, Modal, Input} from "antd";
import {useParams} from "@reach/router";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const { TextArea } = Input

const AddressesCreate = ({show, modalCloser, updater}) => {
    const {customerId} = useParams();
    const [form] = Form.useForm();
    const [loadings, setLoadings] = useState([]);

    const handleSubmit = () => {
        enterLoadingState(setLoadings)

        const {
            title,
            address,
        } = form.getFieldsValue();

        let requestObj = {
            address: address,
            title: title,
            customer: {
                id: customerId
            }
        };

        createAddress(requestObj)
            .then(() => {
                exitLoadingState(setLoadings);
                modalCloser();
                updater();
            })
            .catch(() => exitLoadingState(setLoadings))

    }

    return(
        <React.Fragment>
            <Modal
                title={'Yeni Adres Ekle'}
                onCancel={modalCloser}
                open={show}
                footer={[
                    <Button
                        type={'primary'}
                        key={'SubmitButton'}
                        loading={loadings[0]}
                        onClick={() => form.submit()}
                    >
                        Kaydet
                    </Button>,
                    <Button
                        key={'CancelButton'}
                        onClick={modalCloser}
                    >
                        Kapat
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    onFinish={handleSubmit}
                    labelAlign={"left"}
                    wrapperCol={{span: 16}}
                    labelCol={{span: 8}}
                >
                    <Form.Item
                        name={'title'}
                        label={'Başlık'}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name={'address'}
                        label={'Adres'}
                    >
                        <TextArea />
                    </Form.Item>
                </Form>

            </Modal>
        </React.Fragment>
    )
}
export default AddressesCreate